import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient } from 'src/lib/query-client';
import { globalStyles } from 'src/styles/global-styles';
import { getTheme } from 'src/utils/getTheme';

import { ErrorSnackbarProvider } from '../features/error-snackbar/error-snackbar-provider';

import { SupabaseProvider } from './supabase.provider';

interface AppProviderProps {
    children: JSX.Element;
}

export const AppProvider: FC<AppProviderProps> = ({ children }) => {
    const { theme } = getTheme();

    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <GlobalStyles styles={globalStyles} />
                <BrowserRouter>
                    <SupabaseProvider>
                        <ErrorSnackbarProvider>{children}</ErrorSnackbarProvider>
                    </SupabaseProvider>
                </BrowserRouter>
            </ThemeProvider>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
};
